document.addEventListener("DOMContentLoaded", function() {
  var discountCode = "";
  var discountPercent = 0;

  // Check if Shopify.Checkout is defined and contains discount information
  if (Shopify.Checkout && Shopify.Checkout.discount) {
    discountCode = Shopify.Checkout.discount.code;
    discountPercent = Shopify.Checkout.discount.amount_off / 100;
  }

  // Check if the order amount is $350 or more
  if (Shopify.Checkout && Shopify.Checkout.subtotal_price >= 350) {
    var shippingRates = Shopify.Checkout.shipping_rates;

    // Loop through all the shipping rates
    for (var i = 0; i < shippingRates.length; i++) {
      var shippingRate = shippingRates[i];

      // Check if the shipping rate name is "Free Shipping | 7-14 Business Days"
      if (shippingRate.name === "Free Shipping | 7-14 Business Days") {
        // Calculate the new shipping rate price after the discount is applied
        var newPrice = shippingRate.price - (shippingRate.price * discountPercent);

        // Update the shipping rate price to $0
        shippingRate.update({price: 0, message: "Free Shipping | 7-14 Business Days"});
      }
    }
  }
});
